import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminDiscounts = (args, config) => {
    return useQuery({
        queryKey: ['admin', 'discounts', 'search', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (config = {}) => {
            return generalRequest.get(`/admin/discounts`, {params: config})
        })({...args, page: pageParam})),
    })
}


export const useApiSearchAdminDiscountUsages = (args, config) => {
    return useQuery({
        queryKey: ['admin', 'discounts', 'search', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (config = {}) => {
            return generalRequest.get(`/admin/discounts/${config.id}/usages`, {params: config})
        })({...args, page: pageParam})),
    })
}


export const useApiReadAdminDiscounts = (id) => {
    return useQuery({
        queryKey: ['admin', 'discount', 'get', id],
        queryFn: () => ((async (id) => {
            return generalRequest.get(`/admin/discounts/${id}`)
        })(id)),
    })
}


export function useApiCreateAdminDiscount() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/discounts`, data)
            })(data))
    });
}


export function useApiUpdateAdminDiscount() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.put(`/admin/discounts/${data.id}`, data)
            })(data))
    });
}


export function useApiDeleteAdminDiscount() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.delete(`/admin/discounts/${data.id}`)
            })(data))
    });
}


export function useApiUpdateAdminDiscountEvent() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.put(`/admin/discounts/${data.id}/events`, data)
            })(data))
    });
}


export function useApiUpdateAdminDiscountDedicates() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.put(`/admin/discounts/${data.id}/dedicates`, data)
            })(data))
    });
}


export function useApiPostAdminDiscountDedicatesNotif() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/discounts/${data.id}/dedicates/notif`, data)
            })(data))
    });
}


export function useApiStudentCheckDiscountCode() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.get(`/student/discounts/check`, {params: data})
            })(data))
    });
}

